<div #divContainer class="mat-elevation-z8" >
    <table mat-table [dataSource]="dataSource">
        <div *ngFor="let column of displayedColumns">
            <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef> {{column | uppercase}} 
                    <span *ngIf="column !== 'dispositivos'">{{table.dataTable.unity | unityFormat}}</span>
                </th>
                <td mat-cell *matCellDef="let element"> {{element[column] | numberFormat}} </td>
            </ng-container>
        </div>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>